import type { FC } from 'react';
import { useNavigate } from 'react-router';
import { useObjectIdRouteParam } from 'hooks/useObjectIdRouteParam';
import { Button, Icon, Typography } from '@timeedit/ui-components';
import { Skeleton } from '@timeedit/ui-components/antd';
import './AffiliationHeader.scss';

const { Text, Title } = Typography;

type Props = {
  name?: string | null;
  loading: boolean;
};

const AffiliationHeader: FC<Props> = (props) => {
  const navigate = useNavigate();
  const authConfigId = useObjectIdRouteParam();

  return (
    <div className="affiliation-header">
      <div className="affiliation-header__content">
        <div>
          <Button
            type="text"
            className="affiliation-header__back-button"
            onClick={() =>
              navigate(
                authConfigId
                  ? `/user-management/auth-configs/${authConfigId}`
                  : '/user-management/auth-configs'
              )
            }
          >
            <Icon id="ArrowLeftOutlined" alt="Back" size={18} />
          </Button>
        </div>
        <div>
          <Title className="affiliation-header__title" level={3}>
            Manage affiliations:{' '}
            {props.loading && (
              <Skeleton.Node style={{ width: '180px', height: '18px' }} />
            )}
            {!props.loading && props.name}
          </Title>
          <Text className="affiliation-header__subtitle">
            Create and edit affiliations, and change their order
          </Text>
        </div>
      </div>
    </div>
  );
};

export default AffiliationHeader;
